import React from "react";

const services = [
  {
    title: "LED TV Repair",
    desc: "LED TV repair for backlight, power, display issues. Trusted LED TV repair near me service in Pune with doorstep support.",
    icon: (
      <svg viewBox="0 0 36 36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="32" height="22" rx="3" />
        <line x1="10" y1="30" x2="26" y2="30" />
        <line x1="18" y1="26" x2="18" y2="30" />
        <circle cx="18" cy="15" r="4" fill="none" />
        <path d="M18 11V8" />
        <path d="M18 22v-3" />
        <path d="M14 15h-3" />
        <path d="M25 15h-3" />
      </svg>
    ),
  },
  {
    title: "LCD TV Repair",
    desc: "LCD TV repair for panel issues, lines, color problems. Expert LCD TV repair near you in Pune & Pimpri-Chinchwad.",
    icon: (
      <svg viewBox="0 0 36 36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="32" height="22" rx="3" />
        <line x1="10" y1="30" x2="26" y2="30" />
        <line x1="18" y1="26" x2="18" y2="30" />
        <line x1="8" y1="10" x2="28" y2="10" />
        <line x1="8" y1="14" x2="20" y2="14" />
        <line x1="8" y1="18" x2="24" y2="18" />
      </svg>
    ),
  },
  {
    title: "Smart TV Issues",
    desc: "WiFi connectivity, app crashes, software updates, slow performance — we fix all Smart TV software & hardware issues.",
    icon: (
      <svg viewBox="0 0 36 36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="6" width="32" height="20" rx="3" />
        <line x1="10" y1="30" x2="26" y2="30" />
        <line x1="18" y1="26" x2="18" y2="30" />
        <path d="M14 16 Q18 10 22 16" />
        <path d="M11 18 Q18 8 25 18" />
        <circle cx="18" cy="19" r="1.5" fill="currentColor" />
      </svg>
    ),
  },
  {
    title: "Screen Replacement",
    desc: "Cracked TV screen replacement for all sizes 24 to 75 inch with warranty service in Pune & Pimpri-Chinchwad.",
    icon: (
      <svg viewBox="0 0 36 36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="32" height="22" rx="3" />
        <line x1="10" y1="30" x2="26" y2="30" />
        <line x1="18" y1="26" x2="18" y2="30" />
        <path d="M10 10L26 22" />
        <path d="M26 10L10 22" />
        <path d="M30 8L32 6" />
        <path d="M32 6h-5" />
        <path d="M32 6v5" />
      </svg>
    ),
  },
  {
    title: "Washing Machine Repair",
    desc: "Doorstep washing machine repair near me in Pune. Fix drum, spin, motor, and leakage issues for all brands.",
    icon: (
      <svg viewBox="0 0 36 36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {/* Machine body */}
        <rect x="4" y="2" width="28" height="32" rx="3" />
        {/* Door / drum circle */}
        <circle cx="18" cy="20" r="9" />
        {/* Inner drum */}
        <circle cx="18" cy="20" r="5" />
        {/* Water swirl inside */}
        <path d="M15 20 Q18 16 21 20" />
        {/* Control panel */}
        <line x1="8" y1="8" x2="28" y2="8" />
        {/* Buttons on top */}
        <circle cx="12" cy="5.5" r="1.5" fill="currentColor" />
        <circle cx="18" cy="5.5" r="1.5" fill="currentColor" />
        <rect x="23" y="4" width="4" height="3" rx="1" />
      </svg>
    ),
  },
];

const ServicesSection = () => {
  return (
    <section id="services-section" className="section section-alt" aria-label="Our repair services">
      <div className="section-inner">
        <div className="section-header">
          <div className="section-label">What We Offer</div>
          <h2 className="section-title">Our Expert Services</h2>
          <p className="section-subtitle">
            We provide LED TV repair, LCD TV repair, Smart TV repair and
            washing machine repair in Pune & Pimpri-Chinchwad with doorstep
            service.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-desc">{service.desc}</p>
              <a
                href={`https://wa.me/918007113950?text=Hi%2C%20I%20need%20help%20with%20${encodeURIComponent(service.title)}.%20Please%20share%20details.`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-whatsapp btn-sm"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                Book Now
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
